<template>
  <metainfo></metainfo>

  <component :is="componentToRender" v-if="componentToRender"></component>
</template>

<script>
import {defineComponent, computed, watch, ref} from "vue"
import {useMeta} from "vue-meta"
import {useRoute} from "vue-router"
import Helper from "@/services/Helper"
import TelegramView from "@/modules/post/pages/telegram/view/Index"
import SiteView from "@/modules/post/pages/site/view/Index"
import Api from "./services/Api"

export default defineComponent({
  name: "PostView",
  components: {
    TelegramView,
    SiteView,
  },
  setup() {
    useMeta({title: "Просмотр поста"})

    const route = useRoute()

    const postId = computed(() => {
      return parseInt(route.params.id)
    })

    const componentToRender = ref(null)

    watch(postId, async (id) => {
      Api.post(id).then((resp) => {
        let item = resp.data?.item

        if (item === undefined) {
          throw new Error("Неверные данные")
        }

        let channelId = item?.channel_id
        
        if (isTelegramChannel(channelId)) {
          componentToRender.value = "TelegramView"
        } else if (isSiteChannel(channelId)) {
          componentToRender.value = "SiteView"
        } else {
          throw new Error("Неверный канал")
        }
      })
    }, { immediate: true })

    function isTelegramChannel(channelId) {
      return Helper.inArray([channelId], [2, 3, 4, 5, 7, 8, 9, 10, 11, 12])
    }

    function isSiteChannel(channelId) {
      return Helper.inArray([channelId], [1])
    }

    return {
      componentToRender,
    }
  },
})
</script>
